<template>
    <div v-if="loading" class="fill-height mt-8" align="center" justify="center">
        <v-progress-circular indeterminate class="dark-blue-color"></v-progress-circular>
    </div>

    <div v-else-if="noData" class="mt-8 d-flex justify-center align-center">
        <span class="font-size-lg">{noDataText}</span>
    </div>
</template>

<script>
import { i18n } from '@/i18n';
export default {
    props: {
        noData: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        noDataText: {
            type: String,
            default: () => i18n.t('table.noResults'),
        },
    },
};
</script>
